// @flow

import glamorous from 'glamorous';
import colorUtils from 'color';
import { hover } from 'app/utils/cssUtils';

const Tab = glamorous.li(
  ({ theme }) => ({
    backgroundColor: theme.color.panel,
    color: theme.color.panelAccent,
    margin: 0,
    textAlign: 'center',
    textTransform: 'uppercase',
    transition: 'all 0.2s',
    display: 'flex',
    alignItems: 'stretch',
    flexGrow: 1,
    ...hover({
      opacity: 0.8
    }),
    [theme.mediaQuery.desktopAndUp]: {
      '&:not(:first-of-type)': {
        borderLeft: '1px solid',
        borderColor: colorUtils(theme.color.panelAccent)
          .alpha(0.2)
          .string()
      },
      '&:first-of-type': {
        borderTopLeftRadius: theme.borderRadius.default
      },
      '&:last-child': {
        borderTopRightRadius: theme.borderRadius.default
      }
    }
  }),
  hover(({ theme }) => ({
    backgroundColor: theme.color.panelAccent
  })),
  ({ active, theme, spartan }) =>
    active
      ? {
          backgroundColor: spartan
            ? theme.color.spartanBlue
            : theme.getSkin('Tab.activeBackgroundColor', theme.color.panelSelected),
          color: theme.color.white
        }
      : {},
  ({ disabled, theme }) =>
    disabled
      ? {
          display: 'flex',
          borderColor: theme.color.basis1,
          opacity: 0.6,
          backgroundColor: theme.color.basis5,
          color: theme.color.basis3,
          ...hover({
            opacity: 0.6,
            color: theme.color.basis3,
            backgroundColor: theme.color.basis5
          })
        }
      : {}
);

export default Tab;
